// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__WDTG8","content":"LoadingAlert_content__2G4rk"};